(() => {
  if (customElements.get('cb-mega-menu')) return;
  customElements.define('cb-mega-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const on = (node, event, handler) => node.addEventListener(event, handler, { signal: this.controller.signal });
      const desktop = () => matchMedia('(min-width: 990px) and (hover: hover)').matches;
      const menus = [...this.querySelectorAll('[data-cb-menu]')];
      this.close = except => menus.forEach(menu => { if (menu !== except) menu.open = false; });
      menus.forEach(menu => {
        on(menu, 'toggle', () => { if (menu.open) this.close(menu); });
        on(menu, 'pointerenter', () => {
          clearTimeout(this.timer);
          if (desktop()) this.timer = setTimeout(() => { this.close(menu); menu.open = true; }, 120);
        });
        on(menu, 'pointerleave', () => {
          clearTimeout(this.timer);
          if (desktop() && !menu.contains(document.activeElement)) this.timer = setTimeout(() => { menu.open = false; }, 200);
        });
      });
      on(this, 'keydown', event => {
        if (event.key !== 'Escape') return;
        const open = menus.find(menu => menu.open);
        if (open) { event.preventDefault(); event.stopPropagation(); clearTimeout(this.timer); this.close(); open.querySelector('summary').focus(); }
      });
      on(document, 'pointerdown', event => { if (!this.contains(event.target)) { clearTimeout(this.timer); this.close(); } });
      on(this, 'focusout', event => { if (desktop() && !this.contains(event.relatedTarget)) this.close(); });
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.controller = null; }
  });
})();
